import {
  apiGET,
  apiPATCH,
  apiPOST,
  apiPUT,
  coreApi_default
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/user.ts
var getUserLimits = async () => {
  return await apiGET("/limit", null, { hasNestedData: false });
};
var getUserScheduledLimits = async (id) => {
  return await apiGET(`/limit/${id}/scheduled-actions`, null, {
    hasNestedData: false
  });
};
var resendActivationEmail = async (email, url) => {
  return await apiGET(
    `/auth/activate/${encodeURIComponent(email)}?activation_url=${url}`,
    null,
    { hasNestedData: false }
  );
};
var getSportsbookToken = async () => {
  return await apiGET("/sportsbook/v2/altenar/token", null, {
    hasNestedData: false
  });
};
var getSportsbookTokenV2 = async () => {
  return await apiGET("/sportsbook/v2/altenar/token/v2", null, {
    hasNestedData: false
  });
};
var getAuthKambiUser = async () => {
  return await apiGET("/sportsbook/token", null, { hasNestedData: false });
};
var getCasinoToken = async () => {
  return await apiGET("/casino/oryx/token", null, { hasNestedData: false });
};
var getUserWallet = async () => {
  return await apiGET("/wallet", null, { hasNestedData: false });
};
var getUserLimitPeriods = async () => {
  return await apiGET("/limit/period", null, { hasNestedData: false });
};
var getUserMaximumLimit = async () => {
  return await apiGET("/limit/maximum-days", null, { hasNestedData: false });
};
var setUserLimit = async (model) => {
  return await apiPOST("/limit", model, { hasNestedData: false });
};
var setUserUpdateLimit = async (model) => {
  return await apiPUT(`/limit/${model.id}`, model, {
    hasNestedData: false
  });
};
var updateAccount = async (model) => {
  return await apiPUT("/user", model, { hasNestedData: false });
};
var getUserRequiredData = async (model) => {
  return await apiGET("/user/required-data", model);
};
var updateAddressAndNumber = async (model) => {
  return await apiPUT("/user/update-address-and-mobile-number", model, {
    hasNestedData: false
  });
};
var updatePlayerConsent = async (model) => {
  return await apiPATCH("/user", model, { hasNestedData: false });
};
var updateNationalId = async (model) => {
  return await apiPATCH("/user/update-national-id", model, {
    hasNestedData: false
  });
};
var requestEmailChange = async (email, redirectionUrl) => {
  return await apiPUT(
    "/auth/email",
    { email, redirectionUrl },
    { hasNestedData: false }
  );
};
var updatePassword = async (model) => {
  return await apiPUT("/auth/password", model, { hasNestedData: false });
};
var cashoutVault = async () => {
  return await apiPOST("/player-rewards/claim", {}, { hasNestedData: false });
};
var getUserNotification = async () => {
  return await apiGET("/user/user-notification", null, {
    hasNestedData: false
  });
};
var setVisualizeNotification = async () => {
  return await apiPOST("/user/visualize-notification", null, {
    hasNestedData: false
  });
};
var getUserCapabilitiesAndNationalIdStatus = async () => {
  return await apiGET("/user/capabilities", null, { hasNestedData: false });
};
var acceptTerms = async (model) => {
  return await apiPOST("/user/tc", model, { hasNestedData: false });
};
var acceptPP = async () => {
  return await apiPUT("/user/accept/pp");
};
var getMostRecentPlayedGames = async () => {
  return await apiGET("/casino/recently-played", null, {
    hasNestedData: false
  });
};
var getUserActiveVault = async () => {
  return await apiGET("/player-rewards/active", null, { hasNestedData: false });
};
var getUserClaimedVault = async ({
  pageNumber
}) => {
  return await apiGET(
    "/player-rewards/claimed",
    {
      params: {
        pageNumber,
        pageSize: 6
      }
    },
    { hasNestedData: false }
  );
};
var getUserPopups = async (language) => {
  return await apiGET("/popups", {
    params: { language }
  });
};
var checkUserPopup = async (popupId, status) => {
  return await apiPATCH(
    `/popups/${popupId}`,
    {
      status
    },
    { hasNestedData: false }
  );
};
var getUserIntercomToken = async () => {
  return await apiPOST("/intercom/token", null, { hasNoData: false });
};
var getSmarticoHash = async () => {
  return await coreApi_default.get("/smartico/players/hash");
};
var requestUserActivityReport = async (startingDate, endingDate) => {
  return await apiPOST(
    "/comprehensive-user-activity-report",
    {
      startingDate,
      endingDate
    },
    { hasNestedData: false }
  );
};
var checkUserActivityReport = async (startingDate, endingDate) => {
  return await apiGET(
    "/comprehensive-user-activity-report/verify-data-in-range",
    {
      params: {
        startingDate,
        endingDate
      }
    },
    { hasNestedData: false }
  );
};
var getUserActivityReportRequests = async () => {
  return await apiGET("/comprehensive-user-activity-report/tracking", null, {
    hasNestedData: false
  });
};
var getUserActivityReportFile = async (requestId) => {
  return await apiGET(
    `/comprehensive-user-activity-report/${requestId}/download`,
    null,
    { hasNestedData: false }
  );
};
var getRegisteredBankAccounts = async () => {
  return await apiGET("/player/bank-accounts", null);
};
var autoWithdrawalOptIn = async () => {
  return await apiPOST(
    "/player/auto-withdrawal/opt-in",
    {},
    { hasNestedData: false }
  );
};
var autoWithdrawalOptOut = async () => {
  return await apiPOST(
    "/player/auto-withdrawal/opt-out",
    {},
    { hasNestedData: false }
  );
};
var getAutoWithdrawalStatus = async () => {
  return await apiGET("/player/auto-withdrawal", null, {
    hasNestedData: false
  });
};
var sendUserLocation = async (location) => {
  return await apiPOST("/geo", location);
};
var getUserSignInMethod = async () => {
  return await apiGET("/user/social-sign-in/active");
};
var untieSocialSignIn = async (password, confirmPassword) => {
  return await apiPUT("/user/social-sign-in/untie", {
    password,
    confirm_password: confirmPassword
  });
};
var requestAccountClosure = async (data) => {
  return await apiPOST("/account-closure", data);
};

export {
  getUserLimits,
  getUserScheduledLimits,
  resendActivationEmail,
  getSportsbookToken,
  getSportsbookTokenV2,
  getAuthKambiUser,
  getCasinoToken,
  getUserWallet,
  getUserLimitPeriods,
  getUserMaximumLimit,
  setUserLimit,
  setUserUpdateLimit,
  updateAccount,
  getUserRequiredData,
  updateAddressAndNumber,
  updatePlayerConsent,
  updateNationalId,
  requestEmailChange,
  updatePassword,
  cashoutVault,
  getUserNotification,
  setVisualizeNotification,
  getUserCapabilitiesAndNationalIdStatus,
  acceptTerms,
  acceptPP,
  getMostRecentPlayedGames,
  getUserActiveVault,
  getUserClaimedVault,
  getUserPopups,
  checkUserPopup,
  getUserIntercomToken,
  getSmarticoHash,
  requestUserActivityReport,
  checkUserActivityReport,
  getUserActivityReportRequests,
  getUserActivityReportFile,
  getRegisteredBankAccounts,
  autoWithdrawalOptIn,
  autoWithdrawalOptOut,
  getAutoWithdrawalStatus,
  sendUserLocation,
  getUserSignInMethod,
  untieSocialSignIn,
  requestAccountClosure
};
